import Splide from '@splidejs/splide';
import { initDialog, openDialog } from '../components/common/dialog';

const scrollToSection = (triggerSelector, targetId) => {
  const triggerElements = document.querySelectorAll(triggerSelector);
  if (triggerElements.length) {
    triggerElements.forEach(element => {
      element.addEventListener('click', e => {
        e.preventDefault();
        const headerHeight = document.getElementById('header')?.offsetHeight || 0;
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: targetPosition - headerHeight,
            behavior: 'smooth',
          });
        }
      });
    });
  }
};

const mountSlider = (nodeList, options) => {
  nodeList.forEach(element => {
    let autoplayOption = element.classList.contains('video-slider-autoplay');
    let sliderOptions = {
      ...options,
      autoplay: autoplayOption,
      interval: 5000,
    };

    let sliderElement = new Splide(element, sliderOptions);

    sliderElement.on('overflow', isOverflow => {
      sliderElement.options = {
        arrows: isOverflow,
        drag: isOverflow,
      };
    });

    sliderElement.mount();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  scrollToSection('.work-scroll', 'job-offers');
  scrollToSection('#benefit-scroll', 'benefits');

  mountSlider(document.querySelectorAll('.video-slider'), {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    focus: 0,
    rewind: true,
    pagination: false,
    lazyLoad: 'sequential',
    easing: 'linear',
    arrows: false,
    drag: false,
    breakpoints: {
      699: { perPage: 1 },
      991: { perPage: 2 },
      1439: { perPage: 3 },
    },
  });

  mountSlider(document.querySelectorAll('.workers-slider'), {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    focus: 0,
    rewind: true,
    pagination: false,
    lazyLoad: 'sequential',
    easing: 'linear',
    arrows: false,
    drag: false,
  });

  mountSlider(document.querySelectorAll('.work-slider'), {
    type: 'loop',
    perPage: 5,
    perMove: 1,
    focus: 0,
    rewind: true,
    pagination: false,
    lazyLoad: 'sequential',
    easing: 'linear',
    arrows: false,
    drag: false,
    breakpoints: {
      699: { perPage: 1 },
      991: { perPage: 2 },
      1439: { perPage: 3 },
    },
  });
});

if (document.querySelector('.cms-id-11.lang-pl')) {
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.closer .box-single img');
    const dialog = initDialog('image-dialog');
    const splideList = document.querySelector('#modal-slider .splide__list');
    let splideInstance = null;

    images.forEach((img, index) => {
      img.addEventListener('click', () => {
        openImageDialog(index);
        openDialog(dialog);
      });
    });

    function openImageDialog(initialIndex) {
      splideList.innerHTML = '';

      if (splideInstance) {
        splideInstance.destroy();
        splideInstance = null;
      }

      images.forEach(img => {
        const listItem = document.createElement('li');
        listItem.classList.add('splide__slide');

        const image = document.createElement('img');
        image.src = img.getAttribute('data-src');

        listItem.appendChild(image);
        splideList.appendChild(listItem);
      });

      splideInstance = new Splide('#modal-slider', {
        start: initialIndex,
        type: 'fade',
        perPage: 1,
        pagination: false,
        arrows: true,
        lazyLoad: 'nearby',
      }).mount();
    }
  });
}
